import React from 'react';
import './style.scss';
import Phone from '../../../../common/icons/phone.svg';
import Chat from '../../../../common/icons/chat.svg';
import CMB from '../../../../common/icons/document-lines.svg';
import SMS from '../../../../common/icons/sms.svg';

export default class ContactOption extends React.Component {
    render() {
        const { type, text, click } = this.props;
        return (
            <div className={'contact-option table' + (click ? ' clickable' : '')} onClick={click}>
                <div className="table-row">
                    <div className="table-cell icon-cell">
                        <div className="option-icon">
                            <div className="option-icon-inner">
                                {type === 'tel' ? (
                                    <Phone />
                                ) : type === 'cmb' ? (
                                    <CMB />
                                ) : type === 'chat' ? (
                                    <Chat />
                                ) : type === 'lead' ? (
                                    <SMS />
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="table-cell text-cell">
                        <div
                            className="option-text"
                            dangerouslySetInnerHTML={{
                                __html: text
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
